import React, { useState } from 'react';
import { Box, Grid, Typography } from '@mui/material';
import ArsisPieChart from './PieChart';
import RectangleBox from '../RectangleBox';
import { pvqList } from '../../../constants/pvq';
import { typeMappingHandler } from '../../../constants/keysMapping';
import { KeyValueProps } from '../../../types/Common';
import './pvq.scss';

interface pvqProps {
  pvq: any;
}
const PVQ: React.FC<pvqProps> = (props) => {
  const { pvq } = props;
  const [pvqHover, setPvqHover] = useState('');
  let sumValue = 0;

  const pvqArray = Object.entries(pvq)
    .map((item: any) => {
      sumValue += Math.pow(item[1], 3);
      return {
        key: item[0],
        value: Math.pow(item[1], 3),
        color: typeMappingHandler(item[0]).color,
      };
    })
    .sort((a: any, b: any) => b.value - a.value);

  const pvqSortArray = pvqArray.map((item, index) => {
    return {
      key: item.key,
      value: item.value,
      label: typeMappingHandler(item.key).message,
      priority: index + 1,
      persist: ((item.value / sumValue) * 100).toFixed(2),
    };
  });

  return (
    <Box className='mainPVQContainer'>
      <Box className='header' gap={1}>
        <Typography color='text.main' fontWeight='bold'>
          ارزش ها
        </Typography>

        <Box bgcolor='background.light' className='labelBox'>
          <Typography>PVQ</Typography>
        </Box>
      </Box>

      <Grid container p={1}>
        <Grid item xl={4} lg={12} md={12} xs={12} p={1.5}>
          {pvqArray.map((item: KeyValueProps, index: number) => (
            <RectangleBox
              key={item.key}
              label={typeMappingHandler(item.key).message}
              bgColor={item.color || 'red'}
              index={index}
              showPriority={false}
              pvqHover={pvqHover}
              pvqKey={item.key}
            />
          ))}
        </Grid>

        <Grid item xl={8} lg={12} md={12} xs={12} p={4}>
          <Box className='pieChetContainer'>
            <ArsisPieChart
              data={pvqList.map((_, index) => Math.pow(pvq?.[`A${index + 1}`], 3))}
              pvqSortArray={pvqSortArray}
              labels={pvqList.map((i) => i.key)}
              setPvqHover={setPvqHover}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default PVQ;
